import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MainComponentsModule } from 'app/_main/modules/main-components.module';
import { ButtonModule } from 'core/components/button/button.module';
import { DropdownModule } from 'core/components/dropdown/dropdown.module';
import { FormControlModule } from 'core/components/form-control/form-control.module';
import { IconModule } from 'core/components/icon/icon.module';
import { InputModule } from 'core/components/input/input.module';
import { ListComponentsModule } from 'core/components/list-components/list-components.module';
import { CoreDirectivesModule } from 'core/directives/core-directives/core-directives.module';
import { DateInputModule } from 'core/modules/date-input/date-input.module';
import { TranslateModule } from 'core/modules/i18n/translate.module';
import { PlatformModule } from 'core/modules/platform/platform.module';
import { CorePipesModule } from 'core/pipes/core-pipes/core-pipes.module';
import { BuildingItemComponent } from 'dashboard/components/_ui/building-item/building-item.component';
import { PromotionBuyDwrldCardComponent } from 'dashboard/components/_ui/metaverse-banner/ui/promotion-buy-dwrld-card/promotion-buy-dwrld-card.component';
import { NftPlanFilterComponent } from 'dashboard/components/_ui/nft-plan-filter/nft-plan-filter.component';
import { NftPriceFiltersComponent } from 'dashboard/components/_ui/nft-price-filters/nft-price-filters.component';
import { NftSearchFormComponent } from 'dashboard/components/_ui/nft-search-form/nft-search-form.component';
import { RatingComponent } from 'dashboard/components/_ui/rating/rating.component';
import { StreetItemComponent } from 'dashboard/components/_ui/street-item/street-item.component';
import { StreetProgressComponent } from 'dashboard/components/_ui/street-progress/street-progress.component';
import { TableHeaderComponent } from 'dashboard/components/_ui/table-header/table-header.component';

const exportedDeclarations = [
  StreetItemComponent,
  StreetProgressComponent,
  NftSearchFormComponent,
  NftPriceFiltersComponent,
  NftPlanFilterComponent,
  TableHeaderComponent,
  RatingComponent,
  BuildingItemComponent,
  PromotionBuyDwrldCardComponent,
];

@NgModule({
  declarations: [...exportedDeclarations],
  exports: [...exportedDeclarations],
  imports: [
    MainComponentsModule,
    DateInputModule,
    CommonModule,
    TranslateModule,
    PlatformModule,
    ReactiveFormsModule,
    FormControlModule,
    CorePipesModule,
    ListComponentsModule,
    IconModule,
    DropdownModule,
    InputModule,
    ButtonModule,
    CoreDirectivesModule,
  ],
})
export class DashboardComponentsModule {}
